export const REPORT_TYPE_OPTIONS = [
	{ label: 'ADS_DAILY_REPORT', value: 'ADS_DAILY_REPORT' },
	{ label: 'CLAIMS_TO_DO', value: 'CLAIMS_TO_DO' },
	{ label: 'DOCS_REPORT', value: 'DOCS_REPORT' },
	{ label: 'VALID_CLAIMS_REPORT', value: 'VALID_CLAIMS_REPORT' },
	{ label: 'VALID_INVOICES_REPORT', value: 'VALID_INVOICES_REPORT' },
	{ label: 'CONTRACT_MONTH_REMAINING', value: 'CONTRACT_MONTH_REMAINING' },
	{ label: 'CONSULTANT_REFUND_REPORT', value: 'CONSULTANT_REFUND_REPORT' },
	{ label: 'LOST_PARCELS', value: 'LOST_PARCELS' },
];
